import { getTaskAssignments } from "@/api/assignments/getTaskAssignments"
import { useQuery } from "@tanstack/react-query"

export const useGetTaskAssignments = (taskId: string) => {

  return useQuery({
    queryKey: ['taskAssignments', taskId],
    queryFn: () => getTaskAssignments(taskId),
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 30, // datos permanecen en caché por 30 minutos
    refetchOnMount: true, // revalidar al montar el componente
    refetchOnWindowFocus: false, // no revalidar al enfocar la ventana
  })
}